var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemAdministratorsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,6.9c-1.8-2.2-4.2-4.6-6.4-6.4c-0.9-0.7-2.3-0.7-3.2,0C4.7,2.3,2.3,4.7,0.5,6.9c-0.7,0.9-0.7,2.3,0,3.2 c1.8,2.2,4.2,4.6,6.3,6.3C7.3,16.8,7.8,17,8.4,17c0.6,0,1.2-0.2,1.7-0.5c2.2-1.8,4.6-4.2,6.4-6.4c0,0,0,0,0,0 C17.2,9.2,17.2,7.8,16.5,6.9z M9.5,15.6c-0.7,0.4-1.5,0.5-1.9,0c-0.9-0.7-1.8-1.5-2.7-2.4c0.6-1.5,2-2.5,3.6-2.5c1.6,0,3,1,3.6,2.5 C11.2,14.1,10.3,14.9,9.5,15.6z M8.5,9.6c-1.2,0-2.1-1-2.1-2.1s1-2.1,2.1-2.1s2.1,1,2.1,2.1S9.7,9.6,8.5,9.6z M15.7,9.4 c-0.8,1-1.8,2.1-2.8,3.1c-0.6-1.1-1.6-2-2.7-2.4c0.9-0.6,1.5-1.5,1.5-2.7c0-1.7-1.4-3.2-3.2-3.2S5.3,5.7,5.3,7.4 c0,1.1,0.6,2.1,1.5,2.7c-1.2,0.4-2.1,1.3-2.7,2.4c-1-1-2-2.1-2.8-3.1c-0.4-0.5-0.4-1.3,0-1.9c1.7-2.1,4.1-4.5,6.2-6.2 C7.8,1.1,8.2,1,8.5,1c0.3,0,0.7,0.1,0.9,0.3c2.1,1.7,4.5,4.1,6.2,6.2C16.1,8.1,16.1,8.9,15.7,9.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAdministratorsIcon);
export default __webpack_public_path__ + "static/media/system-administrators-icon.3d647614bb3310329ca41145f3ead4d4.svg";
export { ForwardRef as ReactComponent };